<ng-container *ngIf="column.cellTemplate">
  <ng-container *ngTemplateOutlet="column.cellTemplate; context: { entity: entity }"></ng-container>
</ng-container>
<ng-container *ngIf="!column.cellTemplate && !isDate">
  {{ value }}
</ng-container>
<ng-container *ngIf="!column.cellTemplate && isDate">
  <time [attr.datetime]="value" [attr.title]="value">{{ value | timeAgo }}</time>
</ng-container>
